import { uniqBy } from 'lodash-es';
import { defaultAgreementStatusSelectorFilter } from '~/hooks/useGetAgreements';
import { sortAlphabetically } from '~/infra/utils';
import { timeModel } from '~/models';
import img1 from './img/globalBillingHubPreview1.png';
import img2 from './img/globalBillingHubPreview2.png';
export function getGroupedAgreementOptions(agreements, clientId) {
    if (!clientId) return {
        agreements: [],
        adHocRelationships: []
    };
    const clientAgreements = agreements.filter((a)=>a.customer.id === clientId && !a.isSample);
    const signedAgreements = clientAgreements.filter((a)=>a.agreementStatusV2 != null && defaultAgreementStatusSelectorFilter.includes(a.agreementStatusV2)).sort((a, b)=>{
        var _ref, _ref1;
        var _a_effectiveDate, _b_effectiveDate;
        return ((_ref = (_a_effectiveDate = a.effectiveDate) === null || _a_effectiveDate === void 0 ? void 0 : _a_effectiveDate.getTime()) !== null && _ref !== void 0 ? _ref : 0) - ((_ref1 = (_b_effectiveDate = b.effectiveDate) === null || _b_effectiveDate === void 0 ? void 0 : _b_effectiveDate.getTime()) !== null && _ref1 !== void 0 ? _ref1 : 0);
    }).map((a)=>({
            id: a.id,
            text: a.title || (a.effectiveDate ? "unnamed (from ".concat(timeModel.formatDate(a.effectiveDate), ")") : 'unnamed')
        }));
    const adHocRelationships = clientAgreements.filter((a)=>a.agreementStatusV2 == null).map((a)=>({
            id: a.id
        }));
    return {
        agreements: signedAgreements,
        adHocRelationships
    };
}
export function getClientOptions(agreements) {
    const nonUnique = agreements.filter((a)=>!a.isSample).map((a)=>({
            id: a.customer.id,
            text: a.customer.name
        }));
    const unique = uniqBy(nonUnique, 'text');
    return sortAlphabetically(unique, 'text', {
        ascending: true,
        ignoreCase: true
    });
}
export function getDefaultRelationshipId(agreementOptions) {
    return agreementOptions[0] ? agreementOptions[0].id : '';
}
export const buildSeeWhatItsLikeSteps = (texts)=>[
        {
            title: texts.emptyTitle1(),
            subtitle: texts.emptySubtitle1(),
            image: {
                src: img1,
                width: 850,
                height: 497
            }
        },
        {
            title: texts.emptyTitle2(),
            subtitle: texts.emptySubtitle2(),
            image: {
                src: img2,
                width: 850,
                height: 505
            }
        }
    ];
